exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#manage-references {\n  height: calc(100% - 0%); }\n  #manage-references mat-tab-group {\n    height: 100%; }\n  #manage-references mat-tab-group .mat-tab-body-wrapper {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1; }\n  #manage-references .mat-tab-label {\n    text-transform: uppercase;\n    color: white !important;\n    opacity: 1 !important;\n    font-size: 16px; }\n  #manage-references .mat-tab-group.mat-accent .mat-ink-bar, #manage-references .mat-tab-nav-bar.mat-accent .mat-ink-bar {\n    background-color: #039be5;\n    height: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/manage-references/manage-references.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/manage-references/manage-references.component.scss
// module chunks = main